<template>
    <div :class="['input-box', { 'readonly': readonly == true }]">
        <div class="title" v-if="title" :style="{'color': cl}">{{title}}</div>
        <input :value = "value" :placeholder="placeholder"  :type="type" ref="myInput"
            @input="$emit('input', $event.target.value)"
            @blur="$emit('blur', $event.target.value)"
            @change="$emit('change', $event.target.value)" 
              :disabled = "readonly"/>
        <div class="suffix" v-if="suffix" :style="{'color': cl}">{{suffix}}</div>
    </div>
</template>
<script>
export default {
    name: 'base-input',
    props:{
        value:{
            required: false,
            default:'',
        },
        type:{
            required: false,
             default:'text',
        },
        title:{
            required: false,
            default: '',
        },
        cl:{
            required: false,
            default:'#C39B5E',
        },
        placeholder:{
            required: false,
            default:'请输入内容',
        },
        readonly:{
            required: false,
            default: false,
        },
        suffix:{
            required: false,
            default:'',
        },
    },
    data(){
        return {
        }
    },
    created(){
    },
    methods:{
        focusInput(){
            this.$refs.myInput.focus();
        }
    }
}
</script>
<style lang="scss" scoped>
    .input-box{
        width: 6.22rem;
        height: 1.1rem;
        background: #FFFFFF;
        border: .01rem solid #C39B5E;
        border-radius: .55rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: nowrap;
        margin: 0 auto;
        &.readonly{
            background: transparent;
            border: .01rem solid transparent;
        }

        .title{
            text-align: right;
            height: .44rem;
            line-height: .44rem;
            font-size: .28rem;
            color: #C39B5E;
            min-width: 1.8rem;
        }
        input{
            padding-left: .1rem;
            font-size: .28rem;
            width: 60%;
            display: inline-block;
            color: #000000;
            height: .44rem;
            line-height: .44rem;
            vertical-align: middle;
            background: none;
            &::placeholder{
                color: #C3C3C3;
            }
        }
        .suffix{
            text-align: left;
            height: .44rem;
            line-height: .44rem;
            font-size: .28rem;
            color: #2E2E2E;
            margin-left: .3rem;
            min-width: .7rem;
        }
    }
    
</style>





// WEBPACK FOOTER //
// src/components/BaseInput.vue